// Kurumsal giriş — istemci tarafı PKCE (spec §5.2). verifier bu sekmenin sessionStorage'ında kalır; IdP dönüşündeki
// bilet ANCAK onunla oturuma çevrilir (bileti gören başka biri kullanamaz; giriş CSRF'i yok).
const VERIFIER_KEY = 'flexbee_sso_verifier';
const REDIRECT_KEY = 'flexbee_sso_redirect';

const base64Url = (bytes) => btoa(String.fromCharCode(...bytes))
  .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

export async function createPkcePair() {
  const random = new Uint8Array(32);
  window.crypto.getRandomValues(random);
  const verifier = base64Url(random);
  const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return { verifier, challenge: base64Url(new Uint8Array(digest)) };
}

const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch { /* gizli pencere */ } };
const take = (key) => {
  try {
    const value = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    return value;
  } catch { return null; }
};

export const saveVerifier = (verifier) => write(VERIFIER_KEY, verifier);
export const takeVerifier = () => take(VERIFIER_KEY);
export const saveRedirect = (path) => { if (path && path.startsWith('/')) write(REDIRECT_KEY, path); };
export const takeRedirect = () => {
  const path = take(REDIRECT_KEY);
  return path && path.startsWith('/') && !path.startsWith('//') ? path : null;
};
